export default "__VITE_ASSET__DI67KFVa__"